import { render, staticRenderFns } from "./issues-tab.vue?vue&type=template&id=923039a8"
import script from "./issues-tab.vue?vue&type=script&lang=js"
export * from "./issues-tab.vue?vue&type=script&lang=js"
import style0 from "./issues-tab.vue?vue&type=style&index=0&id=923039a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports